import React from 'react';

import {
    labelWithTooltip,
    levelLabel,
    subLevelLabel,
} from '@shared/components/accordions/accordion-label.utils';
import { NoTranslate } from '@shared/components/no-translate/no-translate';
import { IconCircle } from '@paretogroup/tess';
import * as S from './accordion-label.styles';
import TEST_IDS from '../../utils/_tests/testIds.constants';
import { AccordionLabelWithTooltip } from './accordion-label-with-tooltip';
import { ICON_CIRCLE_TEST_ID } from './accordion-label.constants';

interface Props {
    label: string,
    firstSubLabel?: string,
    secondSubLabel?: string,
    iconColor?: string,
    showTooltip?: boolean,
    explanation: string
}

// eslint-disable-next-line complexity
export const AccordionLabelAndSubLabel = ({
    label,
    firstSubLabel,
    secondSubLabel,
    iconColor,
    showTooltip = false,
    explanation,
}: Partial<Props> = {}) => (
    <S.Wrapper>
        <NoTranslate>
            {labelWithTooltip(label, levelLabel, showTooltip)}
            {firstSubLabel && (
                labelWithTooltip(firstSubLabel,
                    subLevelLabel,
                    secondSubLabel && showTooltip)
            )}
            {secondSubLabel && (
                <S.SubLevelLabel data-testid={TEST_IDS.ACCORDION.ACCORDION_SECOND_SUB_LABEL}>
                    {secondSubLabel}
                </S.SubLevelLabel>
            )}
        </NoTranslate>
        {(iconColor && !explanation)
            && (
                <S.WrapperIcon>
                    <IconCircle
                        size={10}
                        primaryColor={iconColor}
                        dataTestId={ICON_CIRCLE_TEST_ID}
                    />
                </S.WrapperIcon>
            )}
        {explanation
            && (
                <AccordionLabelWithTooltip
                    label=""
                    textInfo={explanation}
                />
            )}
    </S.Wrapper>
);
